import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { GREETINGS } from "../config/site";

// Cycles "Welcome" through every official Indian language + English, Rajasthani & Haryanvi.
export const Greeting = ({ className = "" }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % GREETINGS.length), 1900);
    return () => clearInterval(id);
  }, []);
  const g = GREETINGS[i];
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid="rotating-greeting"
      aria-live="polite"
      title={`Welcome in ${g.name}`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={g.name}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -10, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className={`inline-block whitespace-nowrap leading-5 ${g.font}`}
          dir={g.rtl ? "rtl" : undefined}
        >
          {g.greet}
        </motion.span>
      </AnimatePresence>
      <span className="font-mono text-[9px] uppercase tracking-[0.2em] opacity-60 not-italic whitespace-nowrap">
        {g.name}
      </span>
    </span>
  );
};
